
import React from 'react';

interface JourneyProgressProps {
  currentDay: number;
  totalDays: number;
}

const JourneyProgress: React.FC<JourneyProgressProps> = ({ currentDay, totalDays }) => {
  return (
    <div className="mb-8">
      <div className="w-full bg-gray-200 h-3 rounded-full overflow-hidden">
        <div 
          className="bg-gradient-to-r from-hormony-coral to-hormony-progress h-full rounded-full"
          style={{ width: `${(Math.min(currentDay, totalDays) / totalDays) * 100}%` }}
        ></div>
      </div>
      <div className="flex justify-between mt-2 text-xs text-gray-500">
        <span>Day 1</span>
        <span className="font-medium text-hormony-charcoal">Day {currentDay} / {totalDays}</span>
      </div>
    </div>
  );
};

export default JourneyProgress;
